var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenDrawerNavigation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_237_3422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8398 4.13379V16.7119C16.8398 17.2079 17.2602 17.6104 17.7781 17.6104C18.3281 17.6104 18.75 17.2098 18.75 16.7119V4.13379C18.75 3.63778 18.3281 3.23535 17.7773 3.23535C17.293 3.23535 16.8398 3.63778 16.8398 4.13379ZM8.11328 6.2863L11.7062 9.52554H2.19063C1.67031 9.52441 1.25 9.92871 1.25 10.4229C1.25 10.917 1.67031 11.3213 2.18828 11.3213H11.7039L8.11094 14.5605C7.91406 14.7391 7.81641 14.9749 7.81641 15.2145C7.81641 15.4356 7.9007 15.6566 8.07172 15.8299C8.42598 16.1914 9.01977 16.2088 9.39711 15.8685L14.7135 11.0769C15.0922 10.7376 15.0922 10.1084 14.7135 9.7689L9.39711 4.97723C9.01953 4.63542 8.42578 4.65413 8.07031 5.01725C7.71484 5.37663 7.69922 5.94564 8.11328 6.2863Z",
    fill: "#B4B4B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_237_3422"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5,
    height: 19.1667,
    fill: "white",
    transform: "translate(1.25 0.839478)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenDrawerNavigation);
export default __webpack_public_path__ + "static/media/open-drawer-navigation.84328f12f258c612328bac661434b4bd.svg";
export { ForwardRef as ReactComponent };